import React from "react";
const Button = ({ text, icon, type="button", className="", disabled, onClick }) => {
  return (
    <button
      type={type}
      className={`custom-btn ${className}`}
      disabled={disabled}
      onClick={onClick}
    >
      {icon}
      {text}
    </button>
  );
};
export default Button;
